import React, { useState } from 'react';
import { Button, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import axios from 'axios';

const BatchManagement = ({ 
  selectedOrderIds, 
  onOrdersUpdate,
  userBatches,
  setUserBatches,
  children,
  toolbar,
  airwayBillId  // Add this prop to identify when we're in airway bill view
}) => {
  const [batchSearchModalVisible, setBatchSearchModalVisible] = useState(false);
  const [selectedBatchNumber, setSelectedBatchNumber] = useState('');
  const [newBatchNumber, setNewBatchNumber] = useState('');

  const fetchUserBatches = async () => {
    try {
      const response = await axios.get('/api/orders/user_batches/');
      setUserBatches(response.data || []);
    } catch (error) {
      console.error('Error fetching user batches:', error);
      message.error('获取用户批次数据失败');
    }
  };

  const handleShowBatchSearch = () => {
    if (selectedOrderIds.length === 0) {
      message.warning('请选择要设置批次的订单');
      return;
    }
    fetchUserBatches();
    setBatchSearchModalVisible(true);
  };

  const handleBatchConfirm = async () => {
    if (!selectedBatchNumber) {
      message.warning('请选择批次号');
      return;
    }

    const selectedBatch = userBatches.find(batch => batch.batch_number === selectedBatchNumber);
    if (!selectedBatch) {
      message.error('找不到选中的批次');
      return;
    }

    try {
      // First assign orders to batch
      await axios.post('/api/orders/assign_batch/', {
        order_ids: selectedOrderIds,
        batch_id: selectedBatch.id
      });

      // If we're in airway bill view, also assign the batch to the airway bill
      if (airwayBillId) {
        await axios.post(`/api/orders/airway-bills/${airwayBillId}/assign_batches/`, {
          batch_ids: [selectedBatch.id]
        });
      }

      message.success('批次设置成功');
      setBatchSearchModalVisible(false);
      setSelectedBatchNumber('');
      onOrdersUpdate();
    } catch (error) {
      console.error('Error assigning batch:', error);
      message.error('批次设置失败');
    }
  };

  const handleAddBatch = async () => {
    if (!newBatchNumber.trim()) {
      message.warning('请输入批次号');
      return;
    }

    try {
      await axios.post('/api/orders/batches/', {
        batch_number: newBatchNumber.trim()
      });
      message.success('批次添加成功');
      setNewBatchNumber('');
      fetchUserBatches();
    } catch (error) {
      console.error('Error adding batch:', error);
      message.error('批次添加失败');
    }
  };

  return (
    <>
      {toolbar({handleShowBatchSearch})}
      {React.cloneElement(children, {
        batchSearchModalVisible,
        selectedBatchNumber,
        userBatches,
        newBatchNumber,
        onBatchSearchModalCancel: () => {
          setBatchSearchModalVisible(false);
          setSelectedBatchNumber('');
          setNewBatchNumber('');
        },
        onBatchSearchModalOk: handleBatchConfirm,
        onBatchNumberSelect: setSelectedBatchNumber,
        onNewBatchNumberChange: e => setNewBatchNumber(e.target.value),
        onAddBatch: handleAddBatch,
      })}
    </>
  );
};

export default BatchManagement;
